// Referencias abajo del mapa: los colores de los choferes o, con un chofer en
// foco, los de sus paradas.
import React from "react";
import { COLOR, GRIS, SIN_SENAL_MIN, TURBO } from "../../lib/liveDrivers";
import { STATE_COLOR, STATE_LABEL, StopState } from "../../lib/mapLayers";
import { punto, smallMutedStyle } from "./styles";

export default function Legend({ enFoco, agrupado, turbos = false }: { enFoco: boolean; agrupado: boolean; turbos?: boolean }) {
  return (
    <div style={{ ...smallMutedStyle, marginTop: "10px", display: "flex", gap: "16px", flexWrap: "wrap" }}>
      {enFoco ? (
        <>
          <span>número = orden de la parada (cuadrado: colecta)</span>
          {(Object.keys(STATE_LABEL) as StopState[]).map((s) => <span key={s}><i style={punto(STATE_COLOR[s])} />{STATE_LABEL[s].toLowerCase()}</span>)}
          <span>· línea punteada: sin trazado por calles</span>
        </>
      ) : (
        <>
          <span><i style={punto(COLOR.background)} />segundo plano</span>
          <span><i style={punto(COLOR.foreground)} />app abierta</span>
          <span><i style={punto(COLOR.heartbeat)} />quieto (latido)</span>
          <span><i style={punto(GRIS)} />sin señal hace más de {SIN_SENAL_MIN} min</span>
          <span><i style={punto(TURBO)} />llevando un turbo</span>
          {turbos ? <span>· ⚡ tienda con Turbo hoy; destino del Turbo: rojo sin chofer, amarillo con chofer, verde en camino, gris entregado</span> : null}
          <span>· colecta: punto grande con borde violeta; entrega: punto chico</span>
          {agrupado ? <span>· círculo con número: puntos agrupados (tocalo para acercar)</span> : null}
        </>
      )}
    </div>
  );
}
